import * as React from 'react';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import cn from 'classnames';
import { TemperatureUnits, WeatherTypes } from '@websky/graphql';
import { CdnIcon } from '@shared/ui';
import { useTheme } from '../../theme';
import { getTemperaturePrefix } from '../utils';
export const weatherIcons = {
    [WeatherTypes.Clear]: 'Weather/Clear',
    [WeatherTypes.Clouds]: 'Weather/Сlouds',
    BrokenClouds: 'Weather/Сlouds',
    [WeatherTypes.Drizzle]: 'Weather/Drizzle',
    [WeatherTypes.Thunderstorm]: 'Weather/Thunderstorm',
    [WeatherTypes.Rain]: 'Weather/Rain',
    [WeatherTypes.Snow]: 'Weather/Snow'
};
const Weather = React.memo(({ airport, weatherInfo, className }) => {
    var _a, _b, _c;
    const { Weather: theme } = useTheme('Weather');
    const cityImage = (_c = (_b = (_a = airport === null || airport === void 0 ? void 0 : airport.city) === null || _a === void 0 ? void 0 : _a.images) === null || _b === void 0 ? void 0 : _b.panorama) === null || _c === void 0 ? void 0 : _c.url;
    const weatherIcon = (weatherInfo === null || weatherInfo === void 0 ? void 0 : weatherInfo.type) && weatherIcons[weatherInfo.type];
    const hasImage = !!cityImage;
    return (React.createElement(Card, { classes: { root: cn(theme.card, className, { [theme.card_withoutPanorama]: !hasImage }) } },
        React.createElement(CardActionArea, { classes: { focusHighlight: theme.card__focusHighlight } },
            hasImage && (React.createElement(CardMedia, { classes: { root: theme.card__panorama }, image: cityImage, title: airport.name })),
            React.createElement("div", { className: theme.card__content },
                weatherInfo && (React.createElement(Card, { classes: { root: theme.card__weather } },
                    weatherIcon && React.createElement(CdnIcon, { className: theme.card__weatherIcon, icon: weatherIcon }),
                    React.createElement("div", { className: theme.card__temperature },
                        getTemperaturePrefix(weatherInfo.temperature),
                        Math.abs(Math.round(weatherInfo.temperature)),
                        "\u00B0",
                        weatherInfo.measurement === TemperatureUnits.Fahrenheit && 'F'))),
                React.createElement("div", { className: cn(theme.card__airportName, { [theme.card__airportName_withIATA]: !hasImage }) },
                    !hasImage && React.createElement("div", { className: theme.card__airportIATA }, airport.iata),
                    React.createElement("span", { className: theme.card__airportLink },
                        airport.name,
                        React.createElement(CdnIcon, { className: theme.card__chevronIcon, icon: "Arrow/Chevron_right" })))))));
}, (oldProps, newProps) => {
    return oldProps.weatherInfo && newProps.weatherInfo && oldProps.weatherInfo.type === newProps.weatherInfo.type;
});
export default Weather;
